import type { Event, Set as FestivalSet } from '../types'

/** Lineup names worth a subtitle — the ones the event's name doesn't already spell out. */
export function getLineupNames(event: Pick<Event, 'id' | 'name'>, lineups: Map<string, string[]>): string[] {
  const titleLower = event.name.toLowerCase()
  return (lineups.get(event.id) ?? []).filter(n => !titleLower.includes(n.toLowerCase()))
}

export function getLineupSubtitle(event: Event, lineups: Map<string, string[]>): string | undefined {
  const novel = getLineupNames(event, lineups)
  return novel.length > 0 ? novel.join(', ') : undefined
}

// A set missing its day or times can't be placed on the schedule grid — the
// grid math (timeToMinutes) assumes both times are present and throws without
// them. Seeds do occasionally land timeless sets, so every set read is filtered
// through this rather than guarding at each of the dozen consumers.
export function isTimedSet(set: FestivalSet): boolean {
  return (
    typeof set.day === 'string' &&
    typeof set.startTime === 'string' &&
    typeof set.endTime === 'string'
  )
}
